import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { logout, triggerAlert } from '../utils/commonFunctions'
import { useForm } from 'react-hook-form';
import { getProfileDetails, updateProfile } from '../../src/utils/APIClient';

export default function Sidebar() {
 const [isCondensed, setIsCondensed] = useState(true)

    const navigate = useNavigate();
    const logoutUser = () => {
        try {
            if (logout()) {
                navigate("/login");
            } else {
                triggerAlert("error", "Oops...", "Something went wrong..");
            }
        } catch (error) {
            console.error(error);
            triggerAlert("error", "Oops...", "Something went wrong..");
        }
    };

    const [profile, setProfle] = useState([]);
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();

    const fetchProfile = async () => {
        try {
            const response = await getProfileDetails();
            const responseData = response.data;
            if (response.status === 200) {
                const profile = responseData.profile;
                setProfle(profile);
                setValue('first_name', profile.first_name ? profile.first_name : '');
                setValue('email', profile.email ? profile.email : '');
                setValue('bio', profile.bio ? profile.bio : '');
            } else {
                console.error("Failed to fetch profile:", responseData.message);
            }
        } catch (error) {
            console.error("Failed to fetch profile:", error);
        }
    };
    useEffect(() => {

        fetchProfile();
    }, []);

    const location = useLocation();

    const handleToggle = () => {
        const htmlEl = document.documentElement;
        const currentSize = htmlEl.getAttribute('data-sidenav-size');

        // Toggle the "sidebar-enable" class
        htmlEl.classList.toggle('sidebar-enable');

        // Toggle between 'default' and 'condensed'
        if (currentSize === 'condensed') {
            htmlEl.setAttribute('data-sidenav-size', 'default');
            setIsCondensed(false)
        } else {
            htmlEl.setAttribute('data-sidenav-size', 'condensed');
             setIsCondensed(true)
        }   
    };
    const handleThemeToggle = () => {
        const htmlEl = document.documentElement;
        const currentTheme = htmlEl.getAttribute('data-bs-theme');
        // Toggle light/dark theme
        htmlEl.setAttribute(
            'data-bs-theme',
            currentTheme === 'dark' ? 'light' : 'dark'
        );
    };


    // Utility to check active route
    const isActive = (path) => location.pathname === path
    
    // Helper function to check if current path starts with a given route (for dynamic routes)
    const isActiveRoute = (path) => location.pathname.startsWith(path)

    const [isAutomationOpen, setIsAutomationOpen] = useState(false);

    useEffect(() => {
        const el = document.getElementById("automationHub");
        if (!el) return;

        const onShow = () => setIsAutomationOpen(true);
        const onHide = () => setIsAutomationOpen(false);

        el.addEventListener("show.bs.collapse", onShow);
        el.addEventListener("hide.bs.collapse", onHide);

        return () => {
            el.removeEventListener("show.bs.collapse", onShow);
            el.removeEventListener("hide.bs.collapse", onHide);
        };
    }, []);

    return (
        <div>
            <div className="navbar-custom">
                <div className="topbar container-fluid">
                    <div className="d-flex align-items-center gap-lg-2 gap-1">
                        {/* <div className="logo-topbar">
                            <a href="index.php" className="logo-light">
                                <span className="logo-lg">
                                    <img src="assets/images/logo.png" alt="logo" />
                                </span>
                                <span className="logo-sm">
                                    <img src="assets/images/logo-sm.png" alt="small logo" />
                                </span>
                            </a>
                            <a href="index.php" className="logo-dark">
                                <span className="logo-lg">
                                    <img src="assets/images/logo-dark.png" alt="dark logo" />
                                </span>
                                <span className="logo-sm">
                                    <img src="assets/images/logo-sm.png" alt="small logo" />
                                </span>
                            </a>
                        </div> */}
                        <button className="button-toggle-menu" onClick={handleToggle}>
                            <i className="ri-menu-2-fill"></i>
                        </button>
                        <button className="navbar-toggle" data-bs-toggle="collapse" data-bs-target="#topnav-menu-content">
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </button>
                    </div>

                    <ul className="topbar-menu d-flex align-items-center gap-3">
                        <li className="dropdown d-lg-none">
                            <a className="nav-link dropdown-toggle arrow-none" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                                <i className="ri-search-line fs-22"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-animated dropdown-lg p-0">
                                <form className="p-3">
                                    <input type="search" className="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                                </form>
                            </div>
                        </li>

                        {/* <li className="d-none d-sm-inline-block">
                            <div className="nav-link" id="light-dark-mode" data-bs-toggle="tooltip" data-bs-placement="left" aria-label="Theme Mode" data-bs-original-title="Theme Mode" onClick={handleThemeToggle}>
                                <i className="ri-moon-line fs-22"></i>
                            </div>
                        </li> */}
                        <li className="dropdown">
                            <a className="nav-link dropdown-toggle arrow-none nav-user px-2" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                                <span className="account-user-avatar">
                                    <img src={profile?.profile_picture_url || "assets/images/users/avatar-1.jpg"} alt="user-image" width="40" height="40" className="rounded-circle" />
                                </span>
                                <span className="d-lg-flex flex-column gap-1 d-none">
                                    <h5 className="my-0">
                                        {profile?.first_name || ''} {profile?.last_name || ''}
                                    </h5>

                                    <h6 className="my-0 fw-normal">User</h6>
                                </span>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown">
                                <div className=" dropdown-header noti-title">
                                    <h6 className="text-overflow m-0">Welcome !</h6>
                                </div>
                                <Link to="/user-profile" className="dropdown-item">
                                    <i className="ri-settings-4-line fs-18 align-middle me-1"></i>
                                    <span>Settings</span>
                                </Link>
                                <Link to="/support" className="dropdown-item">
                                    <i className="ri-customer-service-2-line fs-18 align-middle me-1"></i>
                                    <span>Support</span>
                                </Link>
                                <button className="dropdown-item" onClick={logoutUser} type="button">
                                    <i className="ri-logout-box-line fs-18 align-middle me-1"></i>
                                    <span>Logout</span>
                                </button>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>


            <div className="leftside-menu px-1">
                <a href="/dashboard" className="logo logo-light">
                    <span className="logo-lg">
                        <img src="assets/images/logo.png" alt="logo" />
                    </span>
                    <span className="logo-sm">
                        <img src="assets/images/logo-sm.png" alt="small logo" />
                    </span>
                </a>
                <a href="/dashboard" className="logo logo-dark">
                    <span className="logo-lg">
                        <img src="assets/images/logo-dark.png" alt="dark logo" />
                    </span>
                    <span className="logo-sm">
                        <img src="assets/images/logo-sm.png" alt="small logo" />
                    </span>
                </a>
                <div className="button-sm-hover" data-bs-toggle="tooltip" data-bs-placement="right" title="Show Full Sidebar">
                    <i className="ri-checkbox-blank-circle-line align-middle"></i>
                </div>
                <div className="button-close-fullsidebar" onClick={handleToggle}>
                    <i className="ri-close-fill align-middle"></i>
                </div>
                <div className="h-100" id="leftside-menu-container" data-simplebar>
                    <div className="leftbar-user">
                        <a href="#">
                            <img src="assets/images/users/avatar-1.jpg" alt="user-image" height="42" className="rounded-circle shadow-sm" />
                            <span className="leftbar-user-name mt-2">Tosha Minner</span>
                        </a>
                    </div>
                    <ul className="side-nav">
                        <li className={`side-nav-item ${isActive('/dashboard') ? 'menuitem-active' : ''}`} >
                            <Link to="/dashboard" className={`side-nav-link ${isActive('/dashboard') ? 'active' : ''}`}>
                                <i className=" ri-dashboard-line"></i>
                                <span> Dashboard </span>
                            </Link>
                        </li>
                        {/* <li className={`side-nav-item ${isActive('/agentcreation') ? 'menuitem-active' : ''}`}>
                            <Link to="/agentcreation" className={`side-nav-link ${isActive('/agentcreation') ? 'active' : ''}`}>
                                <i className="ri-brain-line"></i>
                                <span> Agent Creation </span>
                            </Link>
                        </li> */}
                        {/* <li className={`side-nav-item ${isActive('/ai_agent') ? 'menuitem-active' : ''}`}>
                            <Link to="/ai_agent" className={`side-nav-link ${isActive('/ai_agent') ? 'active' : ''}`}>
                                <i className=" ri-robot-line"></i>
                                <span>AI Agents </span>
                            </Link>
                        </li> */}
                        {/* <li
                            className={`side-nav-item ${isActive('/folders') ? 'menuitem-active' : ''}`}
                        >
                            <Link
                                to="/folders"
                                className={`side-nav-link ${isActive('/folders') ? 'active' : ''}`}
                            >
                                <div className="d-flex align-items-center gap-2">
                                   <i className="bi bi-bank"></i>
                                    <span>Company</span>
                                </div>
                            </Link>
                        </li> */}
                            <li className={`side-nav-item ${isActive('/phonenumbers') ? 'menuitem-active' : ''}`}>
                            <Link
                                to="/phonenumbers"
                                className={`side-nav-link ${isActive('/phonenumbers') ? 'active' : ''}`}
                            >
                                <i class="ri-contacts-book-line"></i>
                                <span>Phone Numbers</span>
                            </Link>
                        </li>


                         <li className={`side-nav-item ${isActive('/ai_agent')  ? 'menuitem-active' : ''}`}>
                            <Link to="/ai_agent" className={`side-nav-link ${isActive('/ai_agent') ? 'active' : ''}`}>
                                 <div className="d-flex align-items-center gap-2">
                                    <i className="bi-robot"></i>
                                    <span>AI Agents</span>
                                </div>
                            </Link>
                        </li>
                          <li className={`side-nav-item ${isActive('/ivr') || isActive('/create-ivr')  ? 'menuitem-active' : ''}`}>
                            <Link to="/ivr" className={`side-nav-link ${isActive('/ai_agent') ? 'active' : ''}`}>
                                 <div className="d-flex align-items-center gap-2">
                                    <i className="bi-soundwave"></i>
                                    <span>IVR</span>
                                </div>
                            </Link>
                        </li>
                          <li className={`side-nav-item ${isActive('/workflow') || isActive('/ai_agent/ivr') ? 'menuitem-active' : ''}`}>
                            <Link to="/workflow" className={`side-nav-link ${isActive('/ai_agent') ? 'active' : ''}`}>
                                 <div className="d-flex align-items-center gap-2">
                                    <i className="bi-diagram-3"></i>
                                    <span>Work Flow</span>
                                </div>
                            </Link>
                        </li>
                        <li className={`side-nav-item ${isActive('/integrations') ? 'menuitem-active' : ''}`}>
                            <Link
                                to="/integrations"
                                className={`side-nav-link ${isActive('/integrations') ? 'active' : ''}`}
                            >
                                <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-plug"></i>
                                    <span>Integrations</span>
                                </div>
                            </Link>
                        </li>


                        <li className={`side-nav-item ${isActive('/call_logs') ? 'menuitem-active' : ''}`}>
                            <Link to="/call_logs" className={`side-nav-link ${isActive('/call_logs') ? 'active' : ''}`}>
                                <i className="ri-phone-line"></i>
                                <span>Call Logs</span>
                            </Link>
                        </li>
                        <li className={`side-nav-item ${isActive('/usercalllogs') || isActiveRoute('/customerprofile') ? 'menuitem-active' : ''}`}>
                            <Link to="/usercalllogs" className={`side-nav-link ${isActive('/usercalllogs') || isActiveRoute('/customerprofile') ? 'active' : ''}`}>
                                <i className="ri-history-line"></i>
                                <span>User Call Logs</span>
                            </Link>
                        </li>
                        {/* <li className={`side-nav-item ${isActive('/numberbuying') ? 'menuitem-active' : ''}`}>
                            <Link
                                to="/numberbuying"
                                className={`side-nav-link ${isActive('/numberbuying') ? 'active' : ''}`}
                            >
                                <i class="ri-sim-card-line"></i>
                                <span>Number Buying</span>
                            </Link>
                        </li> */}

                    
                        <li className={`side-nav-item ${isActive('/activities') ? 'menuitem-active' : ''}`}>
                            <Link to="/activities" className={`side-nav-link ${isActive('/activities') ? 'active' : ''}`}>
                                <i class="bi bi-list-check"></i>

                                <span>Activities</span>
                            </Link>
                        </li>
                        <li className={`side-nav-item ${isActive('/plans') ? 'menuitem-active' : ''}`}>
                            <Link to="/plans" className={`side-nav-link ${isActive('/plans') ? 'active' : ''}`}>
                                <i className="ri-calendar-event-line"></i>
                                <span>Plans</span>
                            </Link>
                        </li>
                        <li className={`side-nav-item ${isActive('/users') ? 'menuitem-active' : ''}`}>
                            <Link to="/users" className={`side-nav-link ${isActive('/users') ? 'active' : ''}`}>
                                <i className=" ri-user-settings-line"></i>
                                <span>User Management</span>
                            </Link>
                        </li>
                        <li className={`side-nav-item ${isActive('/paymenthistory') || isActive('/invoice') ? 'menuitem-active' : ''}`}>
                            <Link to="/paymenthistory" className={`side-nav-link ${isActive('/paymenthistory') ? 'active' : ''}`}>
                                <i className="ri-wallet-3-fill"></i>
                                <span>Payment History</span>
                            </Link>
                        </li>
                        {/* <li className={`side-nav-item ${isActive('/llmconfigurations')  || isActive('/voiceconfigurations') ? 'menuitem-active' : ''}`}>
                            <a data-bs-toggle="collapse" href="#sidebarPagesAuth" aria-expanded="true" aria-controls="sidebarPagesAuth" className="side-nav-link">
                                <i className="ri-settings-5-line"></i>
                                <span> Configurations </span>
                                <span className="menu-arrow"></span>
                            </a>
                            <div className="collapse" id="sidebarPagesAuth"  >
                                <ul className="side-nav-second-level">
                                    <li className={`  ${isActive('/llmconfigurations')   ? 'menuitem-active' : ''}`}>
                                        <Link to="/llmconfigurations"  className={`side-nav-link ${isActive('/llmconfigurations') ? 'active' : ''}`}>
                                            
                                            <span>LLM Configurations</span>
                                        </Link>
                                       
                                         
                                    </li>
                                    <li className={`  ${isActive('/voiceconfigurations')   ? 'menuitem-active' : ''}`}>
                                        <Link to="/voiceconfigurations"  className={`side-nav-link ${isActive('/voiceconfigurations') ? 'active' : ''}`}>
                                            
                                            <span>Voice Configurations</span>
                                        </Link>
                                         
                                    </li>
                                    <li>
                                        <Link to="/transcriberconfigurations"  className={`side-nav-link ${isActive('/transcriberconfigurations') ? 'active' : ''}`}>
                                            
                                            <span>Transcriber Configurations</span>
                                        </Link>
                                         
                                    </li>
                                    
                                </ul>
                            </div>
                        </li> */}
                        <li className={`side-nav-item settings-bottom ${isActive('/user-profile') ? 'menuitem-active' : ''}`}>
                            <Link to="/user-profile" className={`side-nav-link ${isActive('/user-profile') ? 'active' : ''}`}>
                                <i className="ri-settings-3-line "></i>
                                <span>Settings</span>
                            </Link>
                        </li>
                    </ul>
                    <div className="clearfix"></div>
                </div>
            </div>
        </div>
    )
}
